import { Grid } from '@material-ui/core';
import { Field } from 'formik';
import { EChargeType } from 'interfaces/IEditProduct';
import React, { Fragment } from 'react';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';

import Free from './free';
import Other from './other';
import Single from './single';
import Subscription from './subscription';
import { useEditProduct } from '../../context';

const Payment = () => {
  const { product } = useEditProduct();

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field
            label='Tipo de pagamento'
            id='charge_type'
            name='charge_type'
            autoFocus
            options={[
              { label: 'Única', value: EChargeType.SINGLE },
              { label: 'Assinatura/Recorrência', value: EChargeType.SUBSCRIPTION },
              { label: 'Valor aberto', value: EChargeType.OTHER },
              { label: 'Gratuito', value: EChargeType.FREE },
            ]}
            component={SelectFormField}
            disabled={product.charge_type === EChargeType.SUBSCRIPTION}
          />
        </Grid>
        <Single />
        <Subscription />
        <Free />
        <Other />
      </Grid>
    </Fragment>
  );
};

export default Payment;
